var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-list-item',[_c('v-list-item-content',[_c('div',{staticClass:"text-center justify-center",staticStyle:{"color":"rgba(0, 0, 0, 0.38)"}},[_vm._v("UYAP İmza Bağlantısını Yaptıktan Sonra Senkronize Et Butonuna Basarak Borçlu Bilgilerinizi Güncelleyebilir ve Görebilirsiniz ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }